import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { EventScheduleDetailView } from './EventScheduleDetailView';
import { IEventSchedule } from '../../../../../Models/Event/IEventSchedule'
import { FontIcon, IPanelHeaderRenderer, Text, IPanelProps, MessageBarType, Panel, PanelType, Stack, useTheme, mergeStyles } from '@fluentui/react';
import { IEventSchedulesApi } from '../../../../../Services/API/EventSchedules/IEventSchedulesApi';
import * as Services from '../../../../../Services/Services';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IEventScheduleList } from '../../../../../Models/Event/IIEventScheduleList';


interface IEventScheduleDetailProps {
    id: number;
    eventId: number;
    isOpened: boolean;
    onDismiss: () => void;
    
}


export const EventScheduleDetail: React.FunctionComponent<IEventScheduleDetailProps> = (props) => {
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>();
    const [eventSchedule, setEventSchedule] = React.useState<IEventSchedule>();

    const theme = useTheme();

    const loadData = async (eventId: number, id: number) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const schedulesApi = Services.ServicesProvider.GetService<IEventSchedulesApi>(Services.EventSchedulesApi);
        const result = await schedulesApi.getEventSchedule(eventId, id);
        if (result.isSuccess && result.data) {
            setEventSchedule(result.data);    
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        if (props.eventId > 0 && props.id>0)
            loadData(props.eventId, props.id);

    }, []);

    const iconClass = mergeStyles({
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
        color: theme.palette.themePrimary
    });



    const renderHeader = (props?: IPanelProps, defaultRender?: IPanelHeaderRenderer, headerTextId?: string | undefined): JSX.Element | null => {
        return (<Stack horizontal horizontalAlign="start" styles={{ root: { width: "100%", marginLeft:20 } }}>
            <Stack  horizontalAlign='end' styles={{ root: { width: 80 } }}>
                <FontIcon iconName="Event" className={iconClass} />
            </Stack>

            <Stack horizontal verticalAlign="center">
                <Text styles={{ root: { fontWeight: 600 } }} variant="xLarge">
                    Vlastnostni lekce
                </Text>
            </Stack>
        </Stack>);
    }

    return (<Panel
        isOpen={props.isOpened}
        onDismiss={props.onDismiss}
        type={PanelType.medium}
        headerText="Vlastnosti lekce"
        onRenderHeader={renderHeader}
        closeButtonAriaLabel="Zavřít">

        <EventScheduleDetailView refresh={() => { loadData(props.eventId, props.id) }} eventSchedule={eventSchedule} isOpened={props.isOpened} isLoading={isLoading}
        onDismiss={props.onDismiss}
        propertyChanged={function (key: string, value: any): void {
            throw new Error('Function not implemented.');
            }} />
    </Panel>)
}
